import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";

const ContentContext = createContext(null);

export const ContentProvider = ({ children }) => {
  const [raw, setRaw] = useState(null);
  const [error, setError] = useState(null);

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/content");
      setRaw(data);
      setError(null);
    } catch (e) {
      setError(e);
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const value = useMemo(() => {
    if (!raw) return null;
    const s = raw.settings || {};
    return {
      settings: s,
      CONTACT: s,
      IMAGES: s.images || {},
      HAJJ_GIFTS: { en: s.hajj_gifts_en || [], bn: s.hajj_gifts_bn || [] },
      HAJJ_BOOKING: { deposit: s.hajj_deposit || 0, en: s.hajj_booking_en || "", bn: s.hajj_booking_bn || "" },
      PACKAGES: raw.packages || [],
      HALAL_TOURS: raw.tours || [],
      BLOGS: raw.blogs || [],
      TESTIMONIALS: raw.testimonials || [],
      GALLERY: raw.gallery || [],
      TEAM: raw.team || [],
      PARTNERS: raw.partners || [],
      reload,
    };
  }, [raw, reload]);

  if (!value) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white" data-testid="content-loading">
        {error ? (
          <div className="text-center">
            <p className="text-jannah-ink/70">Could not load content.</p>
            <button onClick={reload} className="mt-4 px-5 py-2 rounded-md bg-jannah-green text-white">Retry</button>
          </div>
        ) : (
          <div className="w-10 h-10 rounded-full border-4 border-jannah-sand border-t-jannah-green animate-spin" />
        )}
      </div>
    );
  }

  return <ContentContext.Provider value={value}>{children}</ContentContext.Provider>;
};

export const useContent = () => useContext(ContentContext);
